// extracted by mini-css-extract-plugin
export var attachmentContainer = "_sd-0";
export var fileList = "_sd-2";
export var removeFileButton = "_sd-1";